import React from 'react';
import { getConfiguration } from '../../utils/configuration';
import { getFormattedTimestamp } from '../../utils/getFormattedTimestamp';
import { getCurrencyValue } from '../../utils/getCurrencyValue';
import ShopReceiptHeader from './common-includes/ShopReceiptHeader';
import ShopBarcode from './common-includes/ShopBarcode';
import ShopReceiptFooter from './common-includes/ShopReceiptFooter';


function VoucherReceipt(props) {
	const conf = getConfiguration();
	
	const cashierNumber = props.cashierNumber?  props.cashierNumber : null;	
	const additionalStyle = {
			"fontFamily" : "sans-serif",
			"fontSize" : "19px"
	}
	const voucherData = props.voucherData;
	
	const printableVoucherBalance = getCurrencyValue(voucherData.physicalVoucher? voucherData.physicalSelfBalance : voucherData.voucherBalance, conf.cs.m, conf.cs.nd, conf.cs.ct);
	return (
		<body style={additionalStyle}>
			<ShopBarcode idSource={voucherData.voucherCode}> </ShopBarcode>
			{
				cashierNumber && (
					<div>NUMERO CASSA: {cashierNumber} </div>
				)	
			}
			<ShopReceiptHeader customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} operationTitle={voucherData.physicalVoucher? "VOUCHER DI GIOCO" : null}></ShopReceiptHeader>
			
			<div>Data e ora: {getFormattedTimestamp()}</div>
			<div>Da riscuotere: {printableVoucherBalance}</div>
			<hr className="hr-line" />
			<div>Id voucher: {voucherData.voucherCode} </div>
			<ShopReceiptFooter></ShopReceiptFooter>
		</body>
    );
}

export default VoucherReceipt;